module.exports = __webpack_public_path__ + "img/sable_loire.b2593186.jpg";